<script>
export default {
  props: [],

  data() {
    return {
      data: {
        form: null,
      },
    };
  },

  mounted() {
    const vm = this;

    let componentName = "form-with-validation";
    let component = null;
    let parent = this.$parent;

    while (parent && !component) {
      if (parent.$options.name === componentName) {
        component = parent;
      }
      parent = parent.$parent;
    }

    this.$nextTick(() => {
      this.form = component;
    });
  },

  render() {
    return this.$scopedSlots.default({
      form: this.form,
    });
  },
};
</script>
